<template>
  
  <table-wrap small :fields="$options.fields" :query="$options.query" :per-page="10">
    <template v-slot:cell(select)="row">
      <b-link @click="add(row)">Toevoegen</b-link>
    </template>
    <template v-for="slot in Object.keys($scopedSlots)" :slot="slot" slot-scope="scope">
      <slot :name="slot" v-bind="scope"/>
    </template>
  </table-wrap>
  
</template>

<script>

import TableWrap from './TableWrap';
export default
{
    components: {TableWrap},
    data()
    {
        return {
            selected: {}
        }
    },
    methods:
    {
        add({item})
        {
            this.$emit('add', item);
        }
    },
    fields:
    [
        {
            key: 'model.brand.name',
            label: 'Merk',
            search: 'STRING'
        },
        {
            key: 'model.name',
            label: 'Naam',
            search: 'STRING'
        },
        {
            key: 'serial',
            label: 'Serienummer',
            search: 'STRING'
        },
        {
            key: 'select',
            label: '',
            tdClass: 'text-right'
        }
    ],
    query: require('../graphql/searchPrinter.query.gql')
}
</script>

<style>
</style>